import {
	MERGE_RULES_CHILDREN_GET,
	MERGE_RULES_CHILDREN_SUCCESS,
	CASH_PERMISSIONS_SUCCESS,
	CONFIG_LOG_GET,
	CONFIG_LOG_SUCCESS,
	PLACE_SEND_MAPPING_GET,
	PLACE_SEND_MAPPING_SUCCESS,
} from '../constants/patchMenu';

// Règles de synchronisation du siège et de chaque établissement, chargées à
// la demande depuis la modale. Les règles du compte courant, elles, sont
// déjà dans state.access.config et ne passent pas par ici.
const initialState = {
	loading: false,
	loaded: false,
	master: {},
	masterPermissions: [],
	// permissions de la base courante (mode maison, compte fils)
	permissions: [],
	children: [],
	// Historique indexé par source : changer d'établissement ne doit pas
	// afficher celui d'un autre le temps du chargement.
	logLoading: false,
	log: {},
	// Correspondance des points de fabrication, indexée par établissement :
	// { [id_company]: { master, child, mappings } }
	placeSendMappingLoading: false,
	placeSendMapping: {},
};

export default function mergeRulesReducer(state = initialState, action) {
	switch (action.type) {
		case MERGE_RULES_CHILDREN_GET:
			return { ...state, loading: true };
		case MERGE_RULES_CHILDREN_SUCCESS:
			return {
				loading: false,
				loaded: true,
				master: action.master,
				masterPermissions: action.masterPermissions || [],
				children: action.children,
				// Relire le parc ne change rien aux correspondances, qui
				// vivent au siège : on les garde.
				placeSendMappingLoading: state.placeSendMappingLoading,
				placeSendMapping: state.placeSendMapping,
			};
		case CONFIG_LOG_GET:
			return { ...state, logLoading: true };
		case CONFIG_LOG_SUCCESS:
			return {
				...state,
				logLoading: false,
				log: { ...state.log, [action.key]: action.entries },
			};
		case PLACE_SEND_MAPPING_GET:
			return { ...state, placeSendMappingLoading: true };
		case PLACE_SEND_MAPPING_SUCCESS:
			return {
				...state,
				placeSendMappingLoading: false,
				placeSendMapping: {
					...state.placeSendMapping,
					[action.key]: action.mapping,
				},
			};
		case CASH_PERMISSIONS_SUCCESS:
			return { ...state, permissions: action.permissions };
		default:
			return state;
	}
}
